import { makeStyles } from "@material-ui/core";

export const LessonCollectableFormStyles = makeStyles((theme) => ({
  dialogTitle: {
    color: "#37474f",
    maxWidth: "80%",
    "& .MuiTypography-root": {
      color: "#37474f",
      whiteSpace: "nowrap",
      overflow: "hidden",
      textOverflow: "ellipsis",
    },
  },
  paper: {
    minWidth: 487,
    maxWidth: 487,
  },
  helperText: {
    textAlign: "right",
    fontFamily: "Roboto",
    fontWeight: 400,
    fontSize: theme.typography.pxToRem(14),
    color: "#828282",
  },
  addCategory: {
    display: "flex",
    flex: "1 auto",
    alignItems: "center",
  },
  addCategoryIcon: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    padding: "8px",
    gap: "8px",
    width: 56,
    height: 56,

    color: "#000000",
    fontStyle: "normal",
    fontWeight: 400,
    fontSize: theme.typography.pxToRem(34),
    lineHeight: 41,
    background: "#E8EAEF",
    borderRadius: 8,
    marginRight: "10px",
    "&:hover": {
      cursor: "pointer",
    },
  },
  addCategoryLabel: {
    color: "#0344DC",
    fontFamily: "Lato",
    fontStyle: "normal",
    fontWeight: 600,
    fontSize: theme.typography.pxToRem(16),
  },
  categoriesTitle: {
    marginTop: "12px",
    color: "#747F9D",
    fontFamily: "Lato",
    fontStyle: "normal",
    fontWeight: 400,
    fontSize: theme.typography.pxToRem(13),
  },
}));
